import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { TabsPage } from '../tabs/tabs';
import { Login } from '../../models/Login';
import { RestProvider } from '../../providers/rest/rest';


declare var require: any;

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage implements OnInit{
  version: string = require( '.../../../package.json').version;
  phone_number:number;
  password:any;
  protected app_version:string;
  public log = new Login();


  constructor(public navCtrl: NavController,public restProvider: RestProvider,private alertController: AlertController,) {}




  ngOnInit() {
    //  this.phone_number = 9876543213;
    //  this.password = "43213";

    // var findup = require('findup-sync');
    // var packagejson = require(findup('package.json'));
    // console.log(packagejson.version); // => '0.0.1'
console.log("version",this.version)
  }
  GoToMainPage() {
    this.log.phone = this.phone_number;
    this.log.password = this.password;
    this.restProvider.postLogin(this.log)
    .subscribe(
      (result) => {
        console.log(result);
        this.navCtrl.push(TabsPage,{user:result});

      },
      error =>
      {
         console.log(error);
         if(error.status == 401)
         {
          let alert = this.alertController.create({
            title: 'Alert',
            subTitle: 'Invalid credentials.Please try again.',
            enableBackdropDismiss:false,
            buttons: [
              {
                text: 'Ok',
                handler: () => {
                  console.log('Yes clicked');
                  this.phone_number = null;
                  this.password = null;
                }
              }
            ]
          });
          alert.present();
          return;
         }
  
         //Put this statement just to continue while testing
        // this.navCtrl.push(TabsPage);

      }
    )



  }
  

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts